import PageHeader from "components/PageHeader";
import {
  TermsAndConditionsContainer,
  Paragraph,
  ParagraphTitle,
  ParagraphContent,
  OrderedList,
  ListItem,
} from "components/Policy/Policy";
import React from "react";
import { Helmet } from "react-helmet";

interface Props {}

const TermsAndConditions: React.FC<Props> = ({}) => {
  return (
    <>
      <Helmet>
        <title>Общи условия</title>
      </Helmet>
      <PageHeader title={"“ИКЛИМА” ЕООД"} subtitle={"Общи условия"} />
      <TermsAndConditionsContainer>
        <Paragraph>
          <ParagraphTitle className="text-body">I. Страни</ParagraphTitle>
          <ParagraphContent className="text-sm">
            Текущите общи условия съдържат рамков договор за покупко-продажба
            между "И КЛИМА” ЕООД, от една страна и лицето, което е изявило по
            електронен път в уебсайта www.i-clima.com съгласие с Общите условия,
            наречено по-долу „Клиент“, от друга.
          </ParagraphContent>
        </Paragraph>
        <Paragraph>
          <ParagraphTitle className="text-body">II. Дефиниции</ParagraphTitle>
          <ParagraphContent className="text-sm">
            При тълкуването и прилагане на текущите Общи условия, посочените
            по-долу термини и изрази имат следното значение:
            <OrderedList>
              <ListItem className="text-sm">
                "И КЛИМА” ЕООД е собственик на уебсайтът www.i-clima.com, чиято
                дефиниция е портален уебсайт (портал) – виртуален търговски и
                правно-информационен ресурс в Интернет, който дава възможност на
                потребителите за ползване на различни услуги, за закупуване на
                продукти чрез хипервръзки към ресурси, разположени на сървъра на{" "}
                <a href=" www.i-clima.com"> www.i-clima.com</a>.
              </ListItem>
              <ListItem className="text-sm">
                „Клиент“ е физическо или юридическо лице, което по електронен
                път е заявило продукти за покупка или запитване/записване за
                използване на услуги от i-clima.com, като по този начин e приело
                настоящите общи условия и е изразило съгласие за сключване на
                договора.
              </ListItem>
            </OrderedList>
          </ParagraphContent>
        </Paragraph>
        <Paragraph>
          <ParagraphTitle className="text-body">III. Поръчка</ParagraphTitle>
          <ParagraphContent className="text-sm">
            За да получи правото да извършва валидни заявки за закупуване на
            предлаганите в "И КЛИМА “ ЕООД - магазин за стоки/продукти/услуги,
            Клиентът трябва:
            <OrderedList>
              <ListItem className="text-sm">
                Да е въвел правилни данни при потвърждаване на поръчката си в
                електронната регистрационна форма, намираща се на интернет адрес
                – i-clima.com.
              </ListItem>
              <ListItem className="text-sm">
                Да се е съгласил с настоящите Общите условия по начина, описан в
                раздел IV.
              </ListItem>
            </OrderedList>
          </ParagraphContent>
        </Paragraph>
        <Paragraph>
          <ParagraphTitle className="text-body">IV. Съгласие</ParagraphTitle>

          <ParagraphContent className="text-sm">
            <OrderedList>
              <ListItem className="text-sm">
                С електронната си поща, регистрирана при успешна поръчка през
                електронния портал всяко ползващо услугите на "И КЛИМА” ЕООД
                лице може да поиска или да се откаже от възможността да ползва
                предоставяните от "И КЛИМА” ЕООД чрез електронния си магазин
                ресурси и услуги с нарочно електронно волеизявление по реда
                описан в параграф.
              </ListItem>
              <ListItem className="text-sm">
                След изразяване на съгласие с настоящите Общи условия
                регистрираното в i-clima.com лице може да ползва предоставяните
                от "И КЛИМА” ЕООД чрез i-clima.com - магазин ресурси и услуги,
                счита се обвързан с клаузите на Общите условия и се задължава да
                ги спазва.
              </ListItem>

              <ListItem className="text-sm">
                С натискане на виртуалния бутон „Продължи“, Клиентът извършва
                електронно изявление по смисъла на Закона за електронния
                документ и електронния подпис, с което декларира, че е запознат
                с настоящите Общи условия и ги приема. Със записването му на
                съответен носител в сървъра на "И КЛИМА” ЕООД чрез общоприет
                стандарт за преобразуване по технически начин, правещ възможно
                неговото възпроизвеждане, електронното изявление придобива
                качеството на електронен документ по смисъла на цитирания закон.
                "И КЛИМА” ЕООД съхранява в лог-файлове на своя сървър IP адреса
                на Клиента, имената на клиента, неговия адрес, валиден телефон и
                е-mail, тази информация е необходима, както за идентифициране на
                Клиента и възпроизвеждане на електронното му изявление за
                приемане на Общите условия, в случай на възникване на правен
                спор, така и за изпращането и получаването за закупената от него
                стока. "И КЛИМА” ЕООД не съхранява информация за банковите и
                картовите тайни на клиента.
              </ListItem>
              <ListItem className="text-sm">
                При възникнал спор кое лице е изявило воля за обвързване с
                текста на Рамковия договор, за страна по него се счита лицето,
                което е заплатило цената на заявената за закупуване стока.
              </ListItem>
            </OrderedList>
          </ParagraphContent>
        </Paragraph>

        <Paragraph>
          <ParagraphTitle className="text-body">
            V. Публикуване на информация за стоките в "И КЛИМА” ЕООД магазин
          </ParagraphTitle>
          <ParagraphContent className="text-sm">
            <OrderedList>
              <ListItem className="text-sm">
                И КЛИМА” ЕООД" публикува на адрес{" "}
                <a href=" www.i-clima.com"> www.i-clima.com</a>. кратко описание
                и цена на всяка от стоките, които могат да се закупят чрез "И
                КЛИМА” ЕООД" магазин.
              </ListItem>
              <ListItem className="text-sm">
                "И КЛИМА” ЕООД" не носи отговорност при невярност на посочената
                от производителя информация за стоката.
              </ListItem>
            </OrderedList>
          </ParagraphContent>
        </Paragraph>
        <Paragraph>
          <ParagraphTitle className="text-body">
            VI. Публична покана
          </ParagraphTitle>
          <ParagraphContent className="text-sm">
            <OrderedList>
              <ListItem className="text-sm">
                Публикуването на описание и цена на стока в електронен портал{" "}
                <a href=" www.i-clima.com"> www.i-clima.com</a>, собственост на
                "И КЛИМА” ЕООД е публична покана по смисъла на чл. 290, ал. 1 от
                Търговския закон да се направи заявление за покупка в
                съответствие с тях по описания в чл. 7 начин.
              </ListItem>
              <ListItem className="text-sm">
                При липса на складова наличност /възможно е някои от стоките да
                се намират все още при производителя/ от заявената стока "И
                КЛИМА” ЕООД в рамките на един работен ден след получаване на
                заявлението за покупка по чл. 7, уведомява Клиента за
                изчерпването й чрез изпращане на съобщение до електронната
                пощенска кутия на Клиента или чрез SMS, Viber/Whatsapp/Messenger
                съобщение или обаждане на телефона предоставен от клиента
              </ListItem>
            </OrderedList>
          </ParagraphContent>
        </Paragraph>
        <Paragraph>
          <ParagraphTitle className="text-body">
            VII. Извършване на заявление за покупка
          </ParagraphTitle>
          <ParagraphContent className="text-sm">
            <OrderedList>
              <ListItem className="text-sm">
                Клиентът получава достъп до формата за извършване на заявления
                за закупуване на предлаганите в "И КЛИМА” ЕООД - магазин стоки
                след като избере стоките и количествата, които желае да закупи и
                ги добави в кошницата за покупки посредством бутон "добави".{" "}
              </ListItem>
              <ListItem className="text-sm">
                Волеизявлението за закупуване на стока от "И КЛИМА” ЕООД магазин
                се счита за извършено след натискане на втория бутон "Продължи"
                в интерфейса на количката. Визуализираното съобщение “Поръчката
                е направена успешно” служи за потвърждение на клиента, че
                информацията по неговата поръчка е изпратена към сървъра на "И
                КЛИМА” ЕООД. В допълнение - след като са избрани и прегледани
                стоките, начина на плащане и начина на доставка се приема че
                клиента се е съгласил с общите условия преди да продължи към
                формата за разплащане.
              </ListItem>
              <ListItem className="text-sm">
                При посочени неверен или сгрешен адрес и/или телефон при
                подаване на заявката за "И КЛИМА” ЕООД би могло да не възниква
                задължение за сключване на договор с Клиента и изпълнение на
                поръчката.
              </ListItem>
            </OrderedList>
          </ParagraphContent>
        </Paragraph>
        <Paragraph>
          <ParagraphTitle className="text-body">
            VIII. Сключване на индивидуален договор
          </ParagraphTitle>
          <ParagraphContent className="text-sm">
            <OrderedList>
              <ListItem className="text-sm">
                Индивидуалният договор се счита сключен след приемане от "И
                КЛИМА” ЕООД на извършеното при условията на чл. 7 заявление за
                покупка.
              </ListItem>
              <ListItem className="text-sm">
                Заявлението за покупка се приема чрез изпращане на съобщение до
                електронна пощенска кутия на Клиента.
              </ListItem>
              <ListItem className="text-sm">
                Договорът поражда действие между страните след проверка на
                наличността на стоката предмет на заявлението за покупка и след
                потвърждаване на валидността на заявката на посочения от Клиента
                телефон за връзка/имейл адрес.
              </ListItem>
            </OrderedList>
          </ParagraphContent>
        </Paragraph>
        <Paragraph>
          <ParagraphTitle className="text-body">IX. Цени</ParagraphTitle>
          <ParagraphContent className="text-sm">
            <OrderedList>
              <ListItem className="text-sm">
                Всички цени са за 1 брой и в български левове с ДДС.{" "}
              </ListItem>
              <ListItem className="text-sm">
                Дължимата от Клиента цена е посочената в поканата за закупуване
                на стоката към момента на извършване на заявлението за покупка
                на същата по начина описан в чл. 7.
              </ListItem>
            </OrderedList>
          </ParagraphContent>
        </Paragraph>
        <Paragraph>
          <ParagraphTitle className="text-body">
            X. Време и начини на плащане
          </ParagraphTitle>
          <ParagraphContent className="text-sm">
            Цената по чл. 9 и разходите по доставката могат да бъдат платени по
            някой от следните начини:
            <OrderedList>
              <ListItem className="text-sm">
                В брой /наложен платеж/ при получаване на стоката от Клиента или
                от трето лице от името на същия
              </ListItem>
              <ListItem className="text-sm">
                По друг указан на уеб страницата на "И КЛИМА” ЕООД – i-clima.com
                начин.
              </ListItem>
            </OrderedList>
          </ParagraphContent>
        </Paragraph>

        <Paragraph>
          <ParagraphTitle className="text-body">
            XI. Права и задължения на страните
          </ParagraphTitle>
          <ParagraphContent className="text-sm">
            "И КЛИМА” ЕООД се задължава:
            <OrderedList>
              <ListItem className="text-sm">
                Да достави в срок заявената за покупка стока
              </ListItem>
              <ListItem className="text-sm">
                Да полага дължимата грижа за изпълнение на своите задължения.
              </ListItem>
            </OrderedList>
          </ParagraphContent>
        </Paragraph>

        <Paragraph>
          <ParagraphTitle className="text-body">
            XII. Задължения за клиента
          </ParagraphTitle>
          <ParagraphContent className="text-sm">
            Клиентът се задължава:
            <OrderedList>
              <ListItem className="text-sm">
                да посочи точен и валиден телефон и адрес за доставка
              </ListItem>
              <ListItem className="text-sm">
                да плати цената на стоката
              </ListItem>
              <ListItem className="text-sm">
                да заплати разходите по доставката, при наличие на такива
              </ListItem>
              <ListItem className="text-sm">
                да осигури достъп и възможност за получаване на стоката
              </ListItem>
              <ListItem className="text-sm"> да получи вещта</ListItem>
            </OrderedList>
          </ParagraphContent>
          <ParagraphContent className="text-sm">
            Клиентът следва:
            <OrderedList>
              <ListItem className="text-sm">
                да не подава фиктивни заявки или друга информация
              </ListItem>
              <ListItem className="text-sm">
                да спазва българското законодателство, приложимите чужди закони,
                настоящите Общи условия, Интернет етиката, правилата на морала и
                добрите нрави
              </ListItem>
              <ListItem className="text-sm">
                да не нарушава чужди имуществени или неимуществени права
              </ListItem>
              <ListItem className="text-sm">
                да не се представя за друго лице или представител на юридическо
                лице или група хора, които не е оправомощен да представлява, или
                по друг начин да заблуждава трети лица относно самоличността си
                или принадлежността си към определена група хора
              </ListItem>
            </OrderedList>
          </ParagraphContent>
        </Paragraph>

        <Paragraph>
          <ParagraphTitle className="text-body">
            XIII. Права на клиента
          </ParagraphTitle>
          <ParagraphContent className="text-sm">
            Клиентът има право в срок от 14 дни да се откаже безусловно от
            договор от разстояние или от договор извън търговския обект, без да
            заплаща каквито и да е разходи, с изключение на тези за доставка в
            случай, че е избрал различен от стандартния най-евтин за търговеца
            начин за доставяне на поръчката, както и разходите за връщането на
            стоката обратно.
            <br />
            <br />
            14-дневният срок започва да тече от датата на:
            <br />
            - сключване на договора – при договор за услуги;
            <br />
            - приемане на стоките от потребителя или от трето лице, различно от
            превозвача
            <br />
            <br />В рамките на 14 дни след заявеното желание за отказ от
            договора клиентът следва да върне стоката на търговеца в добър
            търговски вид, без следи от употреба и/или монтаж и с цялостната
            опаковка, без тя да бъде нарушена по някакъв начин. В срок от 14
            дни, считано от датата, на която е бил уведомен за решението на
            потребителя да се откаже от договора, търговецът възстановява всички
            суми, получени от потребителя, включително разходите за доставка.
          </ParagraphContent>
        </Paragraph>

        <Paragraph>
          <ParagraphTitle className="text-body">
            СТАНДАРТЕН ФОРМУЛЯР ЗА УПРАЖНЯВАНЕ ПРАВО НА ОТКАЗ
          </ParagraphTitle>
          <ParagraphContent className="text-sm">
            До ...........................
            <br />
            /името на търговеца/
            <br />
            ................................................................................
            <br />
            /адрес, ЕИК/
            <br />
            С настоящото уведомявам, че се отказвам от сключения от мен договор
            за покупка на следните стоки/услуги:
            .......................................................... /описание
            на продукта/
            <br />
            Стоката е поръчана на ......................
            <br />
            Стоката е получена на ...................... /посочва се датата на
            получаване от клиента/
            <br />
            .................................................................................../Име
            на клиента/
            <br />
            Гр./с......................................................................
            /Адрес на клиента/
            <br />
            <br />
            ...................................................
            <br />
            /Дата/ /Подпис на клиента/
          </ParagraphContent>
        </Paragraph>
        <Paragraph>
          <ParagraphTitle className="text-body">XIV. Доставка</ParagraphTitle>
          <ParagraphContent className="text-sm">
            <OrderedList>
              <ListItem className="text-sm">
                Заявената за покупка стока се доставя на посочения от Клиента
                адрес за доставка в срок: През зимните месеци до 8 работни дни,
                а през летните до 10 работни дни (или до предварително заявената
                от клиента дата)– за цялата страна
              </ListItem>
              <ListItem className="text-sm">
                Срокът за доставка по ал. 1 започва да тече:При плащане в брой –
                от момента на сключване на договора при условията на чл.
              </ListItem>
              <ListItem className="text-sm">
                Стоката се доставя подходящо опакована съобразно вида й и
                транспорта за доставка.
              </ListItem>
              <ListItem className="text-sm">
                Срока за доставка се счита за изпълнен по отношение на "И КЛИМА”
                ЕООД с предаването на стоката, подходящо опакована съобразно
                вида й за доставка на съответната спедиторска компания избрана
                на клиента.
              </ListItem>
              <ListItem className="text-sm">
                Стоката се доставя с помощта на куриерска фирма Лео Експрес, ОК
                ЕКСПРЕС ЕООД, Еконт ООД и Спиди АД и съгласно техните общи
                условия.
              </ListItem>
            </OrderedList>
          </ParagraphContent>
        </Paragraph>
        <Paragraph>
          <ParagraphTitle className="text-body">
            XV. Предаване на стоката
          </ParagraphTitle>
          <ParagraphContent className="text-sm">
            <OrderedList>
              <ListItem className="text-sm">
                Стоката се предава на Клиента или на трето лице, което приема и
                потвърждава получаването на същата от името на Клиента.
              </ListItem>
              <ListItem className="text-sm">
                В случаите на чл. 10, ал. 1, т. 1 стоката се предава на лицата
                по предходната алинея след заплащане на дължимата цена и
                разходите по доставката.
              </ListItem>
              <ListItem className="text-sm">
                При предаване на стоката Клиентът или третото лице по ал. 1
                подписват придружаващите я документи.
              </ListItem>
              <ListItem className="text-sm">
                При отказ извън случаите по чл. 15, ал. 1, отказът се счита за
                неоснователен и Клиентът дължи заплащане на разходите за
                доставка и връщане на стоката. В този случай Клиентът е длъжен
                да обезщети "И КЛИМА” ЕООД за всички вреди и пропуснати ползи,
                включително и за всякакви други разходи извън разходите за
                доставка и връщане на стоката, настъпили в следствие на отказа.
              </ListItem>
              <ListItem className="text-sm">
                В случай, че Клиентът не бъде намерен в срока за изпълнение на
                доставката на посочения адрес или не бъде осигурен достъп и
                условия за предаване на стоката в този срок, "И КЛИМА” ЕООД се
                освобождава от задължението си да достави заявената за покупка
                стока. Клиентът може да потвърди желанието си да получи стоката
                и след изтичане на срока за доставка, в който не е бил намерен
                на адреса, като поема всички разходи по доставката. В този
                случай започва да тече съответно нов срок за доставка от момента
                на потвърждението по предходното изречение.
              </ListItem>
            </OrderedList>
          </ParagraphContent>
        </Paragraph>

        <Paragraph>
          <ParagraphTitle className="text-body">
            XVI. Право на отказ на клиента
          </ParagraphTitle>
          <ParagraphContent className="text-sm">
            (1)Клиентът има право да откаже получаването на заявената за покупка
            от него стока, когато тя му е доставена при едно от следните
            условия:
            <OrderedList>
              <ListItem className="text-sm">
                Доставената стока очевидно не съответства на заявената за
                покупка от Клиента и това може да се установи чрез обикновения й
                преглед;
              </ListItem>
              <ListItem className="text-sm">
                При транспортирането стоката е повредена;
              </ListItem>
              <ListItem className="text-sm">
                Цената, която Клиентът следва да заплати, не съответства на
                дължимата цена по чл. 9;
              </ListItem>
              <ListItem className="text-sm">
                "И КЛИМА” ЕООД не е спазило срока за доставка, а именно не е
                предало в срока, стоката на съответната спедиторска компания,
                избрана от клиента. "И КЛИМА” ЕООД не може да бъде отговорно и
                да отговаря за щети при недоставена в срок стока или доставена
                стока с дефекти от страна на спедиторската компания, като
                клиента си запазва правото да върне стоката ако желае при
                наличие на такива обстоятелства.
              </ListItem>
              <ListItem className="text-sm"></ListItem>
              <ListItem className="text-sm"></ListItem>
            </OrderedList>
            (2) Отказ за получаване на стоката при условията на предходната
            алинея е недопустим след подписване на придружаващите я документи по
            чл. 14, ал. 3.
            <br />
            (3) При условията на ал. 1, т. 1, както и при несъответствие между
            заявената за покупка и доставената стока, което не е било възможно
            да бъде установено в момента на доставката, Клиентът може да иска
            доставената му стока да бъде заменена със съответстваща на
            направеното от него заявление за покупка в срок от 24 часа от
            получаването й.
          </ParagraphContent>
        </Paragraph>

        <Paragraph>
          <ParagraphTitle className="text-body">
            XVII. Лични данни
          </ParagraphTitle>
          <ParagraphContent className="text-sm">
            <OrderedList>
              <ListItem className="text-sm">
                {" "}
                "И КЛИМА” ЕООД полага максимална грижа за защита на личните
                данни на Клиента, станали известни при попълване на електронната
                форма за извършване на заявление за покупка. Това задължение
                отпада, ако Клиентът е предоставил неверни данни.
              </ListItem>
              <ListItem className="text-sm">
                При спазване на действащото законодателство и клаузите на
                настоящите Общи условия, "И КЛИМА” ЕООД може да използва личните
                данни на Клиента единствено и само за целите, предвидени в
                договора.
              </ListItem>
              <ListItem className="text-sm">
                {" "}
                "И КЛИМА” ЕООД има право да използва информацията по ал. 1 за
                предлагане на стоки и/или услуги на Клиента, за промоции,
                изпращане на поздравления, организиране на томболи, запитвания,
                за статистически и всякакви други законосъобразни цели, освен в
                случай на изрично несъгласие на същия, изпратено на следния
                e-mail адрес: office@i-clima.com
              </ListItem>
              <ListItem className="text-sm">
                Описаните по-горе цели, за които може да се използват данните,
                не са изчерпателно изброени и не пораждат задължения за "И
                КЛИМА” ЕООД. Всякакви други цели, за които се използват данните,
                ще бъдат съобразени с българското законодателство, приложимите
                международни актове, Интернет етиката, правилата на морала и
                добрите нрави.
              </ListItem>
            </OrderedList>
          </ParagraphContent>
        </Paragraph>

        <Paragraph>
          <ParagraphTitle className="text-body">
            XVIII. Разкриване на информацията
          </ParagraphTitle>
          <ParagraphContent className="text-sm">
            “И КЛИМА" ЕООД се задължава да не разкрива никакви лични данни за
            Клиента на трети лица – държавни органи, търговски дружества,
            физически лица и други, освен в случаите когато:
            <OrderedList>
              <ListItem className="text-sm">
                Е получил изричното съгласие на Клиента
              </ListItem>
              <ListItem className="text-sm">
                Информацията е изискана от държавни органи или длъжностни лица,
                които според действащото законодателство са оправомощени да
                изискват и събират такава информация
              </ListItem>
              <ListItem className="text-sm">
                “И КЛИМА" ЕООД е длъжен да предостави информацията по силата на
                закона.
              </ListItem>
            </OrderedList>
          </ParagraphContent>
        </Paragraph>

        <Paragraph>
          <ParagraphTitle className="text-body">
            XIX. Отговорност
          </ParagraphTitle>
          <ParagraphContent className="text-sm">
            “И КЛИМА" ЕООД не носи отговорност за неизпълнение на задълженията
            си по този договор при настъпване на обстоятелства извън контрола на
            “И КЛИМА" ЕООД – случаи на непреодолима сила, случайни събития,
            проблеми в глобалната мрежа на Интернет и чужди сървъри, извън
            контрола на “И КЛИМА" ЕООД както и проблеми с доставките следствие
            по вина на спедиторската компания.
          </ParagraphContent>
        </Paragraph>
        <Paragraph>
          <ParagraphTitle className="text-body">XX. Обезщетения</ParagraphTitle>
          <ParagraphContent className="text-sm">
            Клиентът се задължава да обезщети “И КЛИМА" ЕООД и всички трети лица
            за всички претърпени вреди и пропуснати ползи, включително и за
            всякакви разходи и платени адвокатски възнаграждения, настъпили в
            следствие на предявени искове от и/или платени обезщетения на трети
            лица във връзка с неизпълнение на задълженията му по настоящия
            договор, нарушение на българското законодателство, приложимите чужди
            закони, настоящите Общи условия, добрите нрави или Интернет етиката.
          </ParagraphContent>
        </Paragraph>
      </TermsAndConditionsContainer>
    </>
  );
};

export default TermsAndConditions;
